// src/components/nav/GeneralBottomNav.tsx
// 4-tab nav: Contests / Leagues / How to Play / Stats.
// Blog, Classic, Forum routes remain accessible via direct URL but are not surfaced in nav.

import React from 'react';
import { NavLink } from 'react-router-dom';
import { Trophy } from 'lucide-react';

const NavItem: React.FC<{
    to: string;
    label: string;
    children: React.ReactNode;
}> = ({ to, label, children }) => {
    return (
        <NavLink
            to={to}
            end
            className={({ isActive }) => `
                flex flex-col items-center justify-center w-full pt-1.5 pb-1 mx-0.5 rounded-lg
                transition-colors duration-150 ease-in-out
                active:opacity-70
                ${isActive ? 'bg-accent-yellow text-primary font-bold' : 'text-gray-400'}
            `}
        >
            {children}
            <span className="text-badge font-medium mt-1">{label}</span>
        </NavLink>
    );
};

export const GeneralBottomNav: React.FC = () => {
    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-primary border-t border-gray-700/50 shadow-lg z-40 pb-[env(safe-area-inset-bottom)]">
            <div className="mx-auto flex h-[3.25rem] max-w-md items-center justify-around">
                <NavItem to="/contests" label="Contests">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                </NavItem>

                <NavItem to="/season-long/dashboard" label="Leagues">
                    <Trophy className="h-6 w-6" strokeWidth={2} aria-hidden="true" />
                </NavItem>

                <NavItem to="/scoring" label="How to Play">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                    </svg>
                </NavItem>

                <NavItem to="/stats" label="Stats">
                    {/* Bar-chart icon (matches the "Stats" label) */}
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3v18h18M8 17V9m4 8V5m4 12v-6"></path>
                    </svg>
                </NavItem>
            </div>
        </nav>
    );
};

export default GeneralBottomNav;
